import { EnumValues } from 'common/types';
import { stringEnum } from 'common/utils/objects';
import { ProductPricingDefinition, PurchasedProductPricing } from '../common/types';
import { Subscription } from '../subscriptions/types';

export const CorePlans = [
	'CORE_COMMISSION',
	'CORE_FIXED',
	'CORE_DEMO',
	'CORE_INTERNAL_ONLY',
	'BASIC',
	'GROW',
	'ADVANCED',
	'ENTERPRISE',
] as const;

export const SubscriptionPlans = ['BASIC', 'GROW', 'ADVANCED'] as const;

export const Plans = stringEnum(['LITE', ...CorePlans]);

export type Plan = EnumValues<typeof Plans>;
export const AllPlans = Object.values(Plans);
export type SubscriptionPlan = typeof Plans.BASIC | typeof Plans.GROW | typeof Plans.ADVANCED;

export interface PlanDefinition {
	/**
	 * The unique id of the plan
	 */
	id: Plan;

	/**
	 * A human-readable name of the plan
	 */
	name: string;

	/**
	 * The pricing of this plan, or null if it is free
	 */
	pricing: ProductPricingDefinition | null;

	blockSlots: number;
}

export interface PurchasedPlan {
	/**
	 * The purchased plan
	 */
	plan: Plan;

	/**
	 * When this plan was purchased, or when the billing for the add-on should begin
	 */
	startDate: string;

	/**
	 * The price of this plan for this specific merchant and store
	 */
	pricing: PurchasedProductPricing;

	/**
	 * An optional description, which will be shown in the corresponding invoice row instead of the default description if provided
	 */
	description?: string;

	/**
	 * An optional internal note, which is shown in internal admin
	 */
	internalNote?: string;
	/*
	 * The amount of available add-on slots included in Plan
	 */

	blockSlots: PurchasedPlanBlockSlots;

	/**
	 * Subscription details of the plan
	 */
	subscription?: Subscription;

	campaign?:
		| 'core_commission_to_advanced_with_grow_price'
		| 'core_commission_to_core_demo_inactive_account_disabled'
		| 'core_commission_to_enterprise'
		| 'core_fixed_to_enterprise'
		| 'old_enterprise_to_core_demo'
		| 'old_enterprise_to_core_demo_account_disabled'
		| 'core_demo_to_core_demo_disabled';
}

export type PurchasedPlanBlockSlots =
	| {
			type: 'default';
	  }
	| {
			type: 'custom';
			amount: number;
	  }
	| {
			type: 'unlimited';
	  };
